import { SearchOutlined } from '@ant-design/icons';
import { history, useAccess } from '@umijs/max';
import { Alert, Button, Input, List, Modal, Tag } from 'antd';
import React from 'react';
import { type SearchResult, searchPlatform } from './search';
export default function SearchBox() {
  const access = useAccess() as Record<string, boolean>;
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [items, setItems] = React.useState<SearchResult[]>([]);
  const [failed, setFailed] = React.useState<string[]>([]);
  const [searched, setSearched] = React.useState(false);
  const sequence = React.useRef(0);
  React.useEffect(
    () => () => {
      sequence.current++;
    },
    [],
  );
  const search = async (value: string) => {
    if (!value.trim()) return;
    const requestId = ++sequence.current;
    setLoading(true);
    setItems([]);
    setFailed([]);
    setOpen(true);
    try {
      const result = await searchPlatform(value, access);
      if (sequence.current === requestId) {
        setItems(result.items);
        setFailed(result.failedSources);
        setSearched(true);
      }
    } finally {
      if (sequence.current === requestId) setLoading(false);
    }
  };
  return (
    <>
      <Button
        type="text"
        aria-label="搜索业务对象"
        icon={<SearchOutlined />}
        onClick={() => setOpen(true)}
      />
      <Modal
        title="业务对象搜索"
        open={open}
        footer={null}
        onCancel={() => {
          sequence.current++;
          setLoading(false);
          setOpen(false);
        }}
      >
        <Input.Search
          autoFocus
          placeholder="搜索基金、项目、企业、研究"
          onSearch={search}
          loading={loading}
        />
        {failed.length > 0 && (
          <Alert
            type="warning"
            title={`以下来源加载失败：${failed.join('、')}`}
          />
        )}
        <List
          loading={loading}
          dataSource={items}
          locale={{
            emptyText: searched ? '当前权限下未找到匹配对象' : '请输入关键词',
          }}
          renderItem={(item) => (
            <List.Item>
              <a
                href={item.path}
                onClick={(event) => {
                  event.preventDefault();
                  setOpen(false);
                  history.push(item.path);
                }}
              >
                {item.name}
              </a>
              <Tag>{item.kind}</Tag>
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
}
